import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import type { PublicConfig } from "./types";

export function useConfig() {
  return useQuery({
    queryKey: ["public-config"],
    queryFn: () => api.get<PublicConfig>("/meta/config"),
    staleTime: Infinity,
  });
}
